import { render } from "./usedList.vue?vue&type=template&id=33e08a74"
import script from "./usedList.vue?vue&type=script&lang=js"
export * from "./usedList.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__